import { BusinessSeatsType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueBusinessSeatsTableRow } from './components';
import { venueBusinessSeatsRows } from './data';

type VenueBusinessSeatsTablePropsType = {
  venueBusinessSeats: BusinessSeatsType;
};

export const VenueBusinessSeatsTable: React.FC<VenueBusinessSeatsTablePropsType> = ({
  venueBusinessSeats,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueBusinessSeatsRows.map((row) => (
          <VenueBusinessSeatsTableRow
            key={row.label}
            venueBusinessSeats={venueBusinessSeats}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

